{
  "auth.login.otp.phone.back.button_label": "Back",
  "auth.login.otp.phone.form.continue.button_label": "Continue",
  "auth.login.otp.phone.form.country_code.label": "Country code",
  "auth.login.otp.phone.form.country_code.invalid_error": "Select a country code.",
  "auth.login.otp.phone.form.phone_number.helper_text": "We’ll text you a code to confirm your number.",
  "auth.login.otp.phone.form.phone_number.label": "Phone number",
  "auth.login.otp.phone.form.phone_number.placeholder": "Phone number",
  "auth.login.otp.phone.form.phone_number.invalid_error": "Unable to send code to this phone number. Try using a different one or log in with email.",
  "auth.login.otp.phone.passcode.form.label": "Code",
  "auth.login.otp.phone.passcode.form.placeholder": "Code",
  "auth.login.otp.phone.passcode.form.resend.link_text": "Didn’t get a text? Resend code",
  "auth.login.otp.phone.passcode.form.resend.link_text.resending": "Resending...",
  "auth.login.otp.phone.passcode.form.switch_method.link_text": "Send code to email instead",
  "auth.login.otp.phone.passcode.helper_text": "Enter the code sent to"
}
